import React from 'react'
import { Input, InputProps } from '@rebass/forms'
import { useSTheme } from 'styles/theme'
import { ga4_inputChanged } from 'utils/ga4'

type Props = InputProps & { alwaysDatePicker?: boolean; passwordVisibility?: boolean; fontFamily?: string }

const SInput = React.forwardRef((props: Props, ref) => {
    const { sx = {}, ...otherProps } = props
    const theme = useSTheme()

    let additionalProps = {}
    if (props.alwaysDatePicker) {
        additionalProps = {
            '::-webkit-calendar-picker-indicator': {
                background: 'transparent',
                bottom: '0',
                color: 'transparent',
                cursor: 'pointer',
                height: 'auto',
                left: '0',
                position: 'absolute',
                right: '0',
                top: '0',
                width: 'auto',
            },
        }
    }

    return (
        <Input
            sx={{
                bg: 'inputBg',
                borderRadius: 1,
                px: 5,
                py: 4,
                fontSize: 3,
                border: 'none',
                boxSizing: 'border-box',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: 'inputBorder',
                height: 50,
                fontFamily: props.fontFamily || theme.fonts.default,
                color: 'black',

                '::placeholder': {
                    color: 'inputPlaceholder',
                },
                '&:hover': {
                    borderColor: 'inputBorder',
                },

                '&:focus': {
                    boxShadow: `0px 0px 0px 3px ${theme.colors.inputShadow}`,
                    borderColor: theme.colors.secondaryColor,
                    borderWidth: 1,
                },
                outline: 'none',

                ...additionalProps,
                ...sx,
            }}
            ref={ref}
            {...otherProps}
            onChange={(e) => {
                if (props.maxLength && props.type === 'number') {
                    if (e.target.value.length >= props.maxLength) {
                        e.target.value = e.target.value.slice(0, props.maxLength)
                    }
                }
                ga4_inputChanged(props.name, e.target.value.length === 1)
                if (props.onChange) {
                    props.onChange(e)
                }
            }}
        />
    )
})

SInput.displayName = 'SInput'

export default SInput
